export const CSRF_FIELD_NAME = 'x-csrf-token'
export const DEVICE_CLASS_FIELD_NAME = 'x-ua-device'
export const WEBVIEW_ACCESS_TOKEN = 'x-access-token'
export const X_FEATURE = 'x-featurebranch'
